import { jsonResponseHandling } from '../fetch';
import { fetchWithAuthHeader } from '../../auth';
import { getViewPermission } from '../helpers';
import { apiUrl, TRIP_ALERTS_PATH } from '../api-manager';

export const getAlertsViewPermission = () => getViewPermission(apiUrl(`${TRIP_ALERTS_PATH}/view`));

export const getAlerts = (latestModifyAt) => {
    const controller = new AbortController();
    const options = {
        method: 'GET',
        signal: controller.signal,
        headers: {
            'if-match': latestModifyAt,
            'cache-control': 'no-store',
        },
    };
    return fetchWithAuthHeader(
        apiUrl(`${TRIP_ALERTS_PATH}/alerts`),
        options,
    ).then(async (response) => {
        if (response.ok) {
            if (response.status === 204) {
                return response;
            }
            const res = await response.json();
            controller.abort();
            return res;
        }
        return [];
    });
};

export const dismissAlert = id => fetchWithAuthHeader(
    apiUrl(`${TRIP_ALERTS_PATH}/alerts/${id}`),
    { method: 'DELETE' },
).then(response => jsonResponseHandling(response));
